// src/app/app.config.ts
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LOCALE_ID, ErrorHandler } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { BASIC_ROUTES } from './app.routes';
import { bearerInterceptor } from './auth/bearer.interceptor';
import { JsonDateInterceptor } from './grundlagen/JsonDateInterceptor';

import { RefreshTokenService } from './auth/refresh-token.service';
import { GlobalErrorHandler } from './grundlagen/GlobalErrorHandler';

import { NotificationService } from '@progress/kendo-angular-notification';
import { IconsService } from '@progress/kendo-angular-icons';
import { LocalizationService } from '@progress/kendo-angular-l10n';
import { IntlModule } from '@progress/kendo-angular-intl';
//import '@progress/kendo-angular-intl/locales/de/all';
import { JwtHelperService } from '@auth0/angular-jwt';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(BASIC_ROUTES),

    RefreshTokenService,
    provideHttpClient(withInterceptors([bearerInterceptor, JsonDateInterceptor])),
    provideAnimations(),

    LocalizationService,
    NotificationService,
    IconsService,
    JwtHelperService,

    { provide: LOCALE_ID, useValue: 'de' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    { provide: APP_BASE_HREF, useValue: '/de' },

    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: 'kendo.locale', useValue: 'de-DE' },
  ],
};
